export const STOPPABLE_SERVICE = Symbol('StoppableService');
export const NOTIFICATION_MUTATION_SERVICE = Symbol('NotificationMutationService');
export const BACKGROUND_SERVICE = Symbol('BackgroundService');
